import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../../features/helpers/dateHelpers';
import { HearingStatusTag } from '../../../../components/HearingStatusTag';

const MetaDataBox = ({
  subjectAreaName,
  cityAreaName,
  hearingTypeName,
  startDate,
  hearingStatus,
  deadline,
  esdhNumber,
  hearingTitle,
  copyHearingLink,
  didCopyHearingLink,
}) => {
  const { t: translator } = useTranslation();
  return (
    <div id="info-box-hearing">
      <h3>{translator('components.metaDataBox.header')} </h3>
      <hr className="create-hearing-header-hr" />
      {hearingTypeName ? (
        <div className="create-hearing-info-text-field" id="hearing-type">
          <p className="title">{translator('hearingProperties.hearingType')}</p>
          <p className="value">{hearingTypeName}</p>
        </div>
      ) : null}
      {hearingTitle ? (
        <div className="create-hearing-info-text-field" id="hearing-name">
          <p className="title">{translator('hearingProperties.title')}</p>
          <p className="value">{hearingTitle}</p>
        </div>
      ) : null}
      {subjectAreaName ? (
        <div className="create-hearing-info-text-field" id="hearing-type-name">
          <p className="title">
            {translator('hearingProperties.subjectArea')}{' '}
          </p>
          <p className="value">{subjectAreaName}</p>
        </div>
      ) : null}
      {cityAreaName ? (
        <div className="create-hearing-info-text-field" id="hearing-type-name">
          <p className="title">{translator('hearingProperties.cityArea')} </p>
          <p className="value">{cityAreaName}</p>
        </div>
      ) : null}
      {hearingStatus ? (
        <div className="create-hearing-info-text-field" id="hearing-status">
          <p className="title">
            {translator('hearingProperties.hearingStatus')}{' '}
          </p>
          <HearingStatusTag
            status={hearingStatus}
            className="value"
            translator={translator}
          />
        </div>
      ) : null}
      <div className="create-hearing-info-text-field" id="start-date">
        <p className="title">{translator('hearingProperties.startDate')} </p>
        <p className="value">{startDate ? formatDate(startDate) : '-'}</p>
      </div>
      <div className="create-hearing-info-text-field" id="end-date">
        <p className="title">{translator('hearingProperties.deadlineDate')} </p>
        <p className="value">{deadline ? formatDate(deadline) : '-'}</p>
      </div>
      {esdhNumber ? (
        <div className="create-hearing-info-text-field" id="kle">
          <p className="title">{translator('hearingProperties.caseNumber')} </p>
          <p className="value">{esdhNumber}</p>
        </div>
      ) : null}
      {copyHearingLink ? (
        <div className="create-hearing-info-text-field" id="copy-hearing-link">
          <p className="title">
            {translator('hearingProperties.copyLinkHeader')}
          </p>
          <p
            className="value value--clickable"
            role="button"
            onClick={copyHearingLink}
          >
            {didCopyHearingLink
              ? translator('hearingProperties.didCopyHearingLink')
              : translator('hearingProperties.copyHearingLink')}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export { MetaDataBox };
